import PropTypes from "prop-types";

/**
 * Reusable error alert component for displaying error messages
 *
 * @component
 * @param {Object} props
 * @param {string} [props.message="Unable to load content. Please try again later."] - Error message to display
 * @param {string} [props.className=""] - Additional CSS classes
 */
const ErrorAlert = ({ message = "Unable to load content. Please try again later.", className = "" }) => {
  return (
    <div className={`alert alert-danger text-center ${className}`} role="alert">
      {message}
    </div>
  );
};

ErrorAlert.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};

export default ErrorAlert;
